import React, { useState } from 'react';
import DirectionImage1 from "../../assets/images/unitDetails/DirectionImage1.svg";
import DirectionImage2 from "../../assets/images/unitDetails/DirectionImage2.svg";
import Scroll from '../scroll/scroll';

const UnitDetailsBanner = ({ data }) => {
  console.log('UnitDetailsBanner', data);

  const [loading, setLoading] = useState(false);

  {/*  const handleOpenPdf = async (_id) => {
    const url = `https://centralapi.greengroup.ae/api/property/printUnitDetails/${_id}`;

    setLoading(true);

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (data.body) {
        window.open(data.body, '_blank', 'noopener,noreferrer');
      } else {
        console.error('No PDF URL found in the response');
      }
    } catch (error) {
      console.error('Error fetching the PDF:', error);
    } finally {
      setLoading(false);
    }
  };

  const _id = data[0]._id;*/}

  return (
    <div className='main-unit-details-bg-clr'>
      <div className='container'>
        <div className='unit-details-main-div'>
          {/* left-div */}
          <div className='heading-div-left'>
            <h4>{data[0].unitTitle}</h4>
          </div>
          <div className='unit-details-heading-text-1'>
            <h6>Apartment Area</h6>
            <p>{data[0].suiteAreaInSqft} sqft</p>
            <p>{data[0].suiteAreaInSqM} sqM</p>
          </div>
          <div className='unit-details-heading-text-2'>
            <h6>Terrace Area</h6>
            <p>{data[0].terraceAreaInSqft} sqft</p>
            <p>{data[0].terraceAreaInSqM} sqM</p>
          </div>
          <div className='unit-details-heading-text-3'>
            <h6>Total Area</h6>
            <p>{data[0].totalAreaInSqft} sqft</p>
            <p>{data[0].totalAreaInSqM} sqM</p>
          </div>
          <div className='community-view-div'>
            <h4>Community View</h4>
          </div>

          <div className='middle-div'>
            <img src={data[0].unitImage} alt='unitLayoutImage' />
          </div>

          <div className='key-plan-div'>
            <img src={data[0].keyPlan} alt='KeyPlanImage' />
            <img className='direction-img' src={data[0].direction === "NE" ? DirectionImage1 : DirectionImage2} alt='DirectionImage' />
          </div>

          <div className='main-buttons-div'>
            <div className='button-div'>
              <Scroll targetId="seePricing">
                <button>See Price Plans</button>
              </Scroll>
            </div>
            {/*          <div className='button-div'>
              <button onClick={() => handleOpenPdf(_id)}>
                {loading ? 'Downloading...' : 'Download PDF'}
              </button>
            </div>*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitDetailsBanner;
